import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import 'dotdotdot-js'

@Component({
  selector: 'app-eartupdate-detail',
  templateUrl: './eartupdate-detail.component.html',
  styleUrls: ['./eartupdate-detail.component.scss']
})
export class EartupdateDetailComponent implements OnInit, AfterViewInit {
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  language = JSON.parse(localStorage.getItem('language'))

  constructor(private route: ActivatedRoute, private _mainService: MainService,
    private _sanitizer: DomSanitizer) { }

  pageHeaderStyle = {};
  backgroundPath = 'assets/images/lead/default@2x.png';


  eartupdate: any;
  showeartupdate: any;
  detail: any;
  file_pdf: string;
  eartupdateTitle: string;
  eartupdateType: string;
  eartupdateDate: string;
  pdfUrl_path: any;
  pdfUrl: any;

  id: any;
  private player;
  private ytEvent;

  filesize: any;

  flag: any

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.eartupdate = this.route.params.subscribe(params => {
      this._mainService.getEartUpdateByID(params['id']).subscribe(response => {
        //case news type is text
        if (this.flag == 'th') {
          if (response[0].earthUpdate_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail = this.htmlTransforms(response[0].detail);
            this.detail = this.htmlTransforms(response[0].detail);

            this.showeartupdate = response;
            this.eartupdateTitle = response[0].title;
            this.eartupdateType = response[0].earthUpdate_type;
            this.eartupdateDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].earthUpdate_type === 'image') {
            this.file_pdf = 'no';
            this.showeartupdate = response;
            this.detail = response[0].detail;
            this.eartupdateTitle = response[0].title;
            this.eartupdateType = response[0].earthUpdate_type;
            this.eartupdateDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].earthUpdate_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail;
            this.showeartupdate = response;
            this.pdfUrl = this.urlTransform(response[0].detail);
            this.eartupdateTitle = response[0].title;
            this.eartupdateType = response[0].earthUpdate_type;
            this.filesize = response[0].filesize
            this.eartupdateDate = this._mainService.date_thai(response[0].publicDate);

          }
          else if (response[0].earthUpdate_type === 'vdo') {
            this.file_pdf = 'no';
            this.showeartupdate = response;
            this.detail = response[0].detail;
            this.id = response[0].detail;
            this.eartupdateTitle = response[0].title;
            this.eartupdateType = response[0].earthUpdate_type;
            this.eartupdateDate = this._mainService.date_thai(response[0].publicDate);

          }
        } else {
          if (response[0].earthUpdate_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail_en = this.htmlTransforms(response[0].detail_en);
            this.detail = this.htmlTransforms(response[0].detail_en);

            this.showeartupdate = response;
            this.eartupdateTitle = response[0].title_en;
            this.eartupdateType = response[0].earthUpdate_type;
            this.eartupdateDate = response[0].publicDate;

          } else if (response[0].earthUpdate_type === 'image') {
            this.file_pdf = 'no';
            this.showeartupdate = response;
            this.detail = response[0].detail_en;
            this.eartupdateTitle = response[0].title_en;
            this.eartupdateType = response[0].earthUpdate_type;
            this.eartupdateDate = response[0].publicDate;

          } else if (response[0].earthUpdate_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail_en;
            this.showeartupdate = response;
            this.pdfUrl = this.urlTransform(response[0].detail_en);
            this.eartupdateTitle = response[0].title_en;
            this.eartupdateType = response[0].earthUpdate_type;
            this.filesize = response[0].filesize
            this.eartupdateDate = response[0].publicDate;

          }
          else if (response[0].earthUpdate_type === 'vdo') {
            this.file_pdf = 'no';
            this.showeartupdate = response;
            this.detail = response[0].detail_en;
            this.id = response[0].detail_en;
            this.eartupdateTitle = response[0].title_en;
            this.eartupdateType = response[0].earthUpdate_type;
            this.eartupdateDate = response[0].publicDate;

          }
        }
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,
        })
      })
    })
  }

  ngOnDestroy() {
    this.eartupdate.unsubscribe();
  }

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }

  onStateChange(event) {
    this.ytEvent = event.data;
  }
  savePlayer(player) {
    this.player = player;
  }
}